import {Component} from "preact";
import ConfigService from "../../../services/ConfigService";

export default class Permission extends Component {

    constructor(props) {
        super(props);
        this.store = {
            enabled: false
        };
    }

    componentDidMount() {
        ConfigService.domainActions.subscribe(this.check, true);
    }

    componentWillUnmount() {
        ConfigService.domainActions.unsubscribe(this.check);
    }

    render({permissions, children}, {enabled}, context) {
        return enabled ? (children[0] || null) : null;
    }

    check = () => {
        let enabled = true;
        const permissions = this.props.permissions || [];
        const actions = ConfigService.domainActions() || [];
        for (let i = 0; i < permissions.length; i++) {
            if (!actions.includes(permissions[i])) {
                enabled = false;
                break;
            }
        }
        this.setState({enabled});
    }
}



// WEBPACK FOOTER //
// ./components/common/permission/permission.js